export enum ProductTypes {
    SUBSCRIPTION = 'SUBSCRIPTION',
    TRIAL = 'TRIAL',
    OMS = 'ONE_MEAL_SERVICE',
    STAR_CLEANER = 'STAR_CLEANER',
}
